import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { EventMantenedorFocoService } from 'src/app/services/event-mantenedor-foco.service';
import { FocoService } from 'src/app/services/foco.service';
import { EJECUTOR_OTHERS_ID } from '../../utils/constants';
import { LoginService } from '../../services/login.service';
export class FocoModalComponent {
    constructor(fb, focoService, eventMantenedorFocoService, loginService) {
        this.fb = fb;
        this.focoService = focoService;
        this.eventMantenedorFocoService = eventMantenedorFocoService;
        this.loginService = loginService;
        this.createEdit = new EventEmitter();
        this.accept = new EventEmitter();
        this.reject = new EventEmitter();
        this.enfoques = [];
        this.categoriesWithFocos = [];
        this.categorias = [];
        this.focoCategorias = [];
        this.ejecutoresWithRelatores = [];
        this.categoria = {
            focoId: null,
            descripcion: '',
            estado: true
        };
        this.errors = {
            zona: false,
            estado: false,
            name: false
        };
        this.flags = {
            ejecutor: false,
            relator: false,
            duracionTeorica: false,
            duracionPractica: false,
            fechaEjecucionReal: false,
            Evidencia: false,
            AsignacionParticipantes: false,
            Guardar: false
        };
        this.isRead = false;
        this.flagPassword = false;
        this.showBar = false;
        this.isReadOnEdit = false;
        this.focoCombo = [];
        this.relatorCombo = [];
        this.monthsCombo = [];
        this.ejecutorOthersId = EJECUTOR_OTHERS_ID;
        this.showErrorMessage = false;
        this.showEvidenceMessage = false;
        this.selectedIdZone = null;
        this.confirmationModalHasComment = false;
        this.confirmationModalHasOptions = false;
        this.confirmationModalisCommentObligatory = false;
        this.workersIdSelected = [];
        this.workersSelected = [];
        this.workersColumns = [
            'Rut Trabajador',
            'Nombre',
            'Apellido Paterno',
            'Apellido Materno'
        ];
        this.workersRows = [];
        this.year = new Date().getFullYear();
        this.yearMax = this.year + 4;
        this.loading = false;
        this.evidences = [];
        this.fileData = null;
        this.error = false;
        this.errorMessage = '';
        this.listClass = false;
        this.flagZona = false;
        this.form = this.fb.group({
            evidenceFile: [null]
        });
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.loginService.obtenerPermisosMenu('mantenedores').then((response) => {
                this.rolid = response.data.rolId;
            });
            this.getUltimoId();
            this.selectedIdZone = this.focoCategorias.length > 0 ? Object.values(this.focoCategorias).map(value => value.categoryId) : [];
        });
    }
    getLabel(value, defaultValue) {
        return value ? value.toString() : defaultValue;
    }
    changeInput(field, value, type = '') {
        if (field === 'estadoId') {
            if (value === 'true') {
                this.categoria.estado = true;
            }
            else {
                this.categoria.estado = false;
            }
        }
        this.categoria[field] = value;
    }
    onSave(send = false) {
        this.showErrorMessage = false;
        this.showEvidenceMessage = false;
        if (this.isValid()) {
            this.loading = true;
            if (this.mode === 'Editar') {
                const categoria = this.categoria;
                const request = {
                    newFoco: {
                        focoId: categoria.focoId,
                        descripcion: categoria.descripcion,
                        estado: categoria.estado,
                        categorias: this.selectedIdZone
                    }
                };
                this.focoService.update(request)
                    .then(response => {
                    this.createEdit.emit();
                    this.eventMantenedorFocoService.refreshTable();
                    this.loading = false;
                    this.modalCategoria.dismiss('Cancel');
                })
                    .catch(error => console.error(error));
            }
            else {
                const categoria = this.categoria;
                const request = {
                    newFoco: {
                        focoId: this.ultimoId + 1,
                        descripcion: categoria.descripcion,
                        estado: categoria.estado,
                        categorias: this.selectedIdZone
                    }
                };
                this.focoService.create(request)
                    .then(response => {
                    this.createEdit.emit();
                    this.eventMantenedorFocoService.refreshTable();
                    this.loading = false;
                    this.modalCategoria.dismiss('Cancel');
                })
                    .catch(error => console.error(error));
            }
        }
    }
    isValid() {
        let isValid = true;
        const isNameValid = this.categoria.descripcion && this.categoria.descripcion.length <= 50;
        isValid = isValid ? isNameValid : false;
        this.errors.name = !isNameValid;
        if (this.mode == 'Editar') {
            const isEstadoIdValid = this.categoria.estado != null;
            isValid = isValid ? isEstadoIdValid : false;
            this.errors.estado = !isEstadoIdValid;
        }
        const isZonaValid = this.selectedIdZone != null && this.selectedIdZone != '';
        isValid = isValid ? isZonaValid : false;
        this.errors.zona = !isZonaValid;
        return isValid;
    }
    getUltimoId() {
        return new Promise((resolve, reject) => {
            this.focoService.getUltimoId()
                .then(response => {
                this.ultimoId = response;
            })
                .catch(error => reject(error));
        });
    }
}
